<template>
  <div class="groups">
    <el-table :data="filteredGroups" style="width: 100%">
      <el-table-column label="-" width="50">
        <template slot-scope="scope">
          <group-controls
            :group="scope.row"
            :organization="organization"
            @refresh="$emit('refresh')"
            leftControl />
        </template>
      </el-table-column>
      <el-table-column prop="name" label="Name" />
      <el-table-column label="Auto-enroll" width="120">
        <template slot-scope="scope">
          <i v-if="scope.row.autoEnroll" class="el-icon-check" />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="Members" width="100">
        <template slot-scope="scope">
          {{ memberCount(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" width="120">
        <template slot-scope="scope">
          <group-controls
            :group="scope.row"
            :organization="organization"
            @refresh="$emit('refresh')" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import GroupControls from './Groups/GroupControls'

export default {
  name: 'Groups',
  components: { GroupControls },
  props: {
    organization: {
      type: Object,
      required: true
    },
    search: {
      type: String,
      required: true
    }
  },
  computed: {
    groups () {
      return this.organization.groups || []
    },
    filteredGroups () {
      return this.groups.filter(group => {
        return group.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
      })
    }
  },
  methods: {
    memberCount (group) {
      if (group.members && group.members.length !== undefined) return group.members.length
      if (group.memberships && group.memberships.length !== undefined) return group.memberships.length
      if (group.memberCount !== undefined && group.memberCount !== null) return group.memberCount
      return 0
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/lists/Groups.vue